/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PatchApiV1ExamExamitemidApprove202,
  PatchApiV1ExamExamitemidApprove400,
  PatchApiV1ExamExamitemidApprove401,
  PatchApiV1ExamExamitemidApprove404,
  PatchApiV1ExamExamitemidApprove500,
  PatchApiV1ExamExamitemidApproveMutationRequest,
  PatchApiV1ExamExamitemidApproveMutationResponse,
  PatchApiV1ExamExamitemidApprovePathParams,
} from "../../types/examQuestionLibraryController/PatchApiV1ExamExamitemidApprove.ts";
import { examItemApproveViewModelSchema } from "../examItemApproveViewModelSchema.ts";

export const patchApiV1ExamExamitemidApprovePathParamsSchema = z.object({
  examItemId: z.coerce.number().int(),
}) as unknown as ToZod<PatchApiV1ExamExamitemidApprovePathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const patchApiV1ExamExamitemidApprove202Schema =
  z.any() as unknown as ToZod<PatchApiV1ExamExamitemidApprove202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const patchApiV1ExamExamitemidApprove400Schema =
  z.any() as unknown as ToZod<PatchApiV1ExamExamitemidApprove400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const patchApiV1ExamExamitemidApprove401Schema =
  z.any() as unknown as ToZod<PatchApiV1ExamExamitemidApprove401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const patchApiV1ExamExamitemidApprove404Schema =
  z.any() as unknown as ToZod<PatchApiV1ExamExamitemidApprove404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const patchApiV1ExamExamitemidApprove500Schema =
  z.any() as unknown as ToZod<PatchApiV1ExamExamitemidApprove500>;

export const patchApiV1ExamExamitemidApproveMutationRequestSchema = z.lazy(
  () => examItemApproveViewModelSchema,
) as unknown as ToZod<PatchApiV1ExamExamitemidApproveMutationRequest>;

export const patchApiV1ExamExamitemidApproveMutationResponseSchema = z.lazy(
  () => patchApiV1ExamExamitemidApprove202Schema,
) as unknown as ToZod<PatchApiV1ExamExamitemidApproveMutationResponse>;
